<template>
  <div class="flex flex-col items-center">
    <RevButton
      full-width="always"
      :to="PARTNER_WEBSITE_URL[partnerName]"
      variant="secondary"
    >
      {{ i18n(translations.help) }}
    </RevButton>

    <RevButton
      v-if="displayCancelButton"
      class="mb-8 mt-12"
      :disabled="disableCancelButton"
      full-width="always"
      variant="secondary"
    >
      {{ i18n(translations.cancel) }}
    </RevButton>

    <div
      v-if="displayCancelButton && disableCancelButton"
      class="text-static-default-low caption"
    >
      {{ i18n(translations.cancelDisabledExplanation) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevButton } from '@ds/components/Button'

import { PARTNER_WEBSITE_URL } from '~/scopes/dashboard/services-hub/constant'
import type { PolicyDetails } from '~/scopes/dashboard/services-hub/types'

import translations from './HelpAndCancelButtons.translations'

const i18n = useI18n()
const { marketplace } = useMarketplace()

const props = defineProps<{
  partnerName: PolicyDetails['policy']['offer']['partnerName']
  withinWithdrawalPeriod: PolicyDetails['policy']['withinWithdrawalPeriod']
  policyState: PolicyDetails['policy']['state']
  policyStartDate: PolicyDetails['policy']['startDate']
}>()

const displayCancelButton = computed(() => {
  if (
    props.policyState === 'ACTIVE' ||
    props.policyState === 'ON_HOLD' ||
    props.policyState === 'NOT_STARTED'
  ) {
    return true
  }

  return false
})

const disableCancelButton = computed(() => {
  if (props.policyStartDate) {
    const policyStartDate = new Date(props.policyStartDate)
    const currentDate = new Date()

    const oneYearInMs = 365 * 24 * 60 * 60 * 1000
    if (currentDate.getTime() - policyStartDate.getTime() > oneYearInMs) {
      return false
    }
  }

  if (marketplace.marketplaceCode === 'EU' && !props.withinWithdrawalPeriod) {
    return true
  }

  return false
})
</script>
